import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import formatData from "./formatData";
import { _sendBatch } from "./sendBatch";
import { formatMessage, getTimeZone } from "./tools";

// 新加坡和美国日志服务器
var imdapServers = ['https://imdap-sea.alipay.com/loggw/dwcookieLogGet.do', 'https://imdap.alipay.com/loggw/dwcookieLogGet.do'];
var dataCache = [];
var logTask = 0;
var batchCount = 5;
var sendFrequency = 1000;
var server = '';

/**
 * 发送上报请求
 * @param data D-VM或者D-AE日志
 */
var _send = function _send(data) {
  var _window, _window$autoReportCon, _window2, _window2$autoReportCo;
  var imdapServerIndex = ((_window = window) === null || _window === void 0 ? void 0 : (_window$autoReportCon = _window.autoReportConfig) === null || _window$autoReportCon === void 0 ? void 0 : _window$autoReportCon.imdapServerIndex) || 0;
  // 优先取外部传入的server，默认新加坡服务器
  server = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$autoReportCo = _window2.autoReportConfig) === null || _window2$autoReportCo === void 0 ? void 0 : _window2$autoReportCo.server) || imdapServers[imdapServerIndex];
  if (!server) {
    console.warn('Please configure the receiving address of tracert service');
    return;
  }
  // 先缓存，分批发送
  dataCache.push(data);
  _httpRequest();
};

/**
 * 分批发送请求
 */
function _httpRequest() {
  var _window3, _window3$autoReportCo;
  if (logTask !== 0) return;
  // 先发送再等待
  _sendBatch === null || _sendBatch === void 0 ? void 0 : _sendBatch({
    datas: dataCache.splice(0, batchCount),
    dataCache: dataCache,
    server: server,
    platform: (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$autoReportCo = _window3.autoReportConfig) === null || _window3$autoReportCo === void 0 ? void 0 : _window3$autoReportCo.platform
  });

  // 每次发送5个请求，间隔一秒
  logTask = setInterval(function () {
    var datas = dataCache.splice(0, batchCount);
    if (!datas.length) {
      clearInterval(logTask);
      logTask = 0;
      return true;
    }
    if (datas.length) {
      var _window4, _window4$autoReportCo;
      _sendBatch === null || _sendBatch === void 0 ? void 0 : _sendBatch({
        datas: datas,
        dataCache: dataCache,
        server: server,
        platform: (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$autoReportCo = _window4.autoReportConfig) === null || _window4$autoReportCo === void 0 ? void 0 : _window4$autoReportCo.platform
      });
    }
    _httpRequest();
  }, sendFrequency);
}

/**
 * 发送日志和性能数据
 * @param options
 */
function report(options) {
  var _window5, _window5$autoReportCo, _window6, _window6$location, _window7, _window7$navigator, _param, _window8, _window8$autoReportCo, _window9, _window9$autoReportCo, _window10, _window10$autoReportC, _window11, _window11$autoReportC;
  if (((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$autoReportCo = _window5.autoReportConfig) === null || _window5$autoReportCo === void 0 ? void 0 : _window5$autoReportCo.isReport) === false) return;
  if (typeof Promise === 'undefined') return;
  var _options$title = options.title,
    title = _options$title === void 0 ? '' : _options$title,
    _options$msg = options.msg,
    msg = _options$msg === void 0 ? '' : _options$msg,
    _options$extra = options.extra,
    extra = _options$extra === void 0 ? {} : _options$extra,
    _options$logType = options.logType,
    logType = _options$logType === void 0 ? 'error' : _options$logType;
  var param4 = (_param = {}, _defineProperty(_param, "web_".concat(logType, "_title"), title), _defineProperty(_param, "web_".concat(logType, "_message"), formatMessage(msg).join('^')), _defineProperty(_param, "URL", (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$location = _window6.location) === null || _window6$location === void 0 ? void 0 : _window6$location.href), _defineProperty(_param, "userAgent", (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$navigator = _window7.navigator) === null || _window7$navigator === void 0 ? void 0 : _window7$navigator.userAgent), _defineProperty(_param, "idengine_timezone", getTimeZone()), _param);
  formatData({
    logType: logType,
    programVersion: ((_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$autoReportCo = _window8.autoReportConfig) === null || _window8$autoReportCo === void 0 ? void 0 : _window8$autoReportCo.programVersion) || '',
    productId: (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$autoReportCo = _window9.autoReportConfig) === null || _window9$autoReportCo === void 0 ? void 0 : _window9$autoReportCo.productId,
    appId: (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window10$autoReportC = _window10.autoReportConfig) === null || _window10$autoReportC === void 0 ? void 0 : _window10$autoReportC.appId,
    bizType: (_window11 = window) === null || _window11 === void 0 ? void 0 : (_window11$autoReportC = _window11.autoReportConfig) === null || _window11$autoReportC === void 0 ? void 0 : _window11$autoReportC.bizType,
    param4: Object.assign({}, param4, extra)
  }).then(function (format) {
    _send(format);
  });
}
export default report;